import {
  useArchivedGames,
  useGameDoc,
  useGameEvents,
  useInviteDoc,
  usePlayers,
  usePregameDoc,
  usePlayoffSeries,
  useRecentEvents,
  useScheduleGames,
  useSeasons,
  useTeamDoc,
} from "../data/repository";
import { remoteValue } from "../data/remoteState";
import { usePresenceList, usePresenceWriter } from "./usePresence";
import type { TeamQueries } from "./teamTypes";

interface TeamQueryOptions {
  teamId: string;
  uid: string | null;
  manageOpen: boolean;
}

export function useTeamQueries({
  teamId,
  uid,
  manageOpen,
}: TeamQueryOptions): TeamQueries {
  const team = useTeamDoc(teamId);
  const activeGameId = remoteValue(team)?.activeGameId ?? null;

  usePresenceWriter(teamId, uid);

  return {
    team,
    pregame: usePregameDoc(teamId),
    players: usePlayers(teamId),
    game: useGameDoc(teamId, activeGameId),
    events: useGameEvents(teamId, activeGameId),
    archivedGames: useArchivedGames(teamId),
    scheduleGames: useScheduleGames(teamId),
    playoffSeries: usePlayoffSeries(teamId),
    seasons: useSeasons(teamId),
    invite: useInviteDoc(teamId),
    recentEvents: useRecentEvents(manageOpen ? teamId : null),
    presence: usePresenceList(teamId),
  };
}
